import HOCWatchValue from 'components/common/hoc-watch-value';
import * as React from 'react';

import ActivityGuestCard from './activity/items';
import CruiseItems from './cruise/items';
import DocumentPurchaseItems from './document';
import FlightPurchaseItems from './flight/items';
import HotelPurchaseHotelSection from './hotel/items';
import ProductCard from './product/product-card';

export default function PurchaseItems() {
  const values = HOCWatchValue({
    keys: ['approvalable.status', 'approvalable.transactionType'],
  });
  const transactionType = values['approvalable.transactionType'];

  if (transactionType === 'flight') {
    return <FlightPurchaseItems />;
  }
  if (transactionType === 'activity') {
    return <ActivityGuestCard />;
  }
  if (transactionType === 'cruise') {
    return <CruiseItems />;
  }

  if (transactionType === 'hotel') {
    return <HotelPurchaseHotelSection />;
  }

  if (transactionType === 'document') {
    return <DocumentPurchaseItems />;
  }

  if (transactionType === 'product') {
    return <ProductCard />;
  }

  return null;
}
